import React from 'react';
import { useStyletron } from 'baseui';
type propT = {
  strokeColor?: string;
  size?: number;
};
const Icon = ({
  strokeColor,
  size = 16
}: propT) => {
  const [_, theme] = useStyletron();
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 25" fill="none" preserveAspectRatio="xMidYMid meet">
      <line x1="5.25987" y1="21.4286" x2="18.0624" y2="21.4286" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
      <line y1="-1" x2="12.6925" y2="-1" transform="matrix(-0.311695 0.950182 -0.951917 -0.306357 20.0489 9.74774)" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
      <line y1="-1" x2="12.6925" y2="-1" transform="matrix(0.310989 0.950414 0.952142 -0.305657 3.29475 9.74629)" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
      <line y1="-1" x2="12.759" y2="-1" transform="matrix(-0.803744 0.594975 0.60231 0.798263 12.8415 4.466)" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
      <line y1="-1" x2="12.7582" y2="-1" transform="matrix(0.799334 0.600887 -0.608212 0.793774 10.4941 4.42857)" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
      <ellipse cx="18.2493" cy="21.5714" rx="3.44869" ry="3.42857" fill={strokeColor ? strokeColor : 'currentColor'} />
      <ellipse cx="18.2493" cy="21.5714" rx="1.47801" ry="1.46939" fill={theme.colors.backgroundSecondary} />
      <ellipse cx="5.89151" cy="21.5714" rx="3.44869" ry="3.42857" fill={strokeColor ? strokeColor : 'currentColor'} />
      <ellipse cx="5.89151" cy="21.5714" rx="1.47801" ry="1.46939" fill={theme.colors.backgroundSecondary} />
      <ellipse cx="3.44869" cy="10.4286" rx="3.44869" ry="3.42857" fill={strokeColor ? strokeColor : 'currentColor'} />
      <ellipse cx="3.44869" cy="10.4286" rx="1.47801" ry="1.46939" fill={theme.colors.backgroundSecondary} />
      <ellipse cx="20.5499" cy="10.43" rx="3.45013" ry="3.43" fill={strokeColor ? strokeColor : 'currentColor'} />
      <ellipse cx="20.5499" cy="10.43" rx="1.47863" ry="1.47" fill={theme.colors.backgroundSecondary} />
      <ellipse cx="12.0704" cy="3.42857" rx="3.44869" ry="3.42857" fill={strokeColor ? strokeColor : 'currentColor'} />
      <ellipse cx="12.0704" cy="3.42857" rx="1.47801" ry="1.46939" fill={theme.colors.backgroundSecondary} />
    </svg>;
};
export default Icon;